import React from 'react';
import { ParametersModal } from './components/ParametersModal/ParametersModal.component';
import { DimensionsModal } from './components/DimensionsModal/DimensionsModal.component';
import { useQuantitatives } from '../../contexts/QuantitativesContext';
import { GenerateQuantitatives } from './components/GenerateQuantitatives/GenerateQuantitatives.component';
import { api } from '../../services/api';
import { GeneralInfoModal } from '../GeneralInfoModal/GeneralInfoModal.component';
import { Loader } from '../Loader/Loader.component';
import { defaultStateAlertModal } from '../../contexts/QuantitativeContext.types';
import { WarningCircleAlertIcon } from '../Icons';

export function WarehouseQuantitatives() {
  const {
    isModalOpen,
    setIsModalOpen,
    quantitativesData,
    setQuantitativesData,
    setAlertModalIsOpen,
  } = useQuantitatives();

  const { generateToken, postQuantitatives } = api;

  const fetchGenerateToken = async ({ payload }) => {
    setAlertModalIsOpen({
      open: true,
      title: 'Gerando quantidades',
      description: 'Aguarde enquanto calculamos as quantidades necessárias',
      icon: <Loader />,
      submitDangerous: false,
      loader: true,
    });

    try {
      const response = await generateToken(payload);
      const tokenGenerate = response.data as string;
      if (tokenGenerate) {
        const responseQuantitativo = await postQuantitatives(payload, tokenGenerate);
        if (responseQuantitativo.data) {
          setQuantitativesData(responseQuantitativo.data);
          setAlertModalIsOpen(defaultStateAlertModal);
        }
      }
    } catch (error) {
      console.error(error);
      setAlertModalIsOpen({
        open: true,
        submitDangerous: true,
        title: 'Erro ao gerar quantitativos',
        description: error.message,
        icon: WarningCircleAlertIcon,
        textSubmit: 'Ok',
        onSubmit: () => {},
      });
    }
  };

  return (
    <>
      {isModalOpen.open === 'GeneralInfo' && (
        <GeneralInfoModal
          isOpen={isModalOpen.open === 'GeneralInfo'}
          onClose={() =>
            setIsModalOpen({
              open: null,
            })
          }
        />
      )}

      {isModalOpen.open === 'DimensionsModal' && (
        <DimensionsModal
          isOpen={isModalOpen.open === 'DimensionsModal'}
          onClose={() => {
            setIsModalOpen({ open: null });
          }}
          onSubmit={() => setIsModalOpen({ open: 'ParametersModal' })}
        />
      )}

      {isModalOpen.open === 'ParametersModal' && (
        <ParametersModal
          isOpen={isModalOpen.open === 'ParametersModal'}
          onReturn={() => setIsModalOpen({ open: 'DimensionsModal' })}
          onClose={() =>
            setIsModalOpen({
              open: null,
            })
          }
          onSubmit={(payload) => {
            setIsModalOpen({ open: null });
            fetchGenerateToken({ payload });
          }}
        />
      )}

      {quantitativesData && <GenerateQuantitatives data={quantitativesData} />}
    </>
  );
}
